import { DirectionEnum } from './../../../../../../../shared/models/directions-enum';


import { ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { firstValueFrom, Subscription } from 'rxjs';
import { JpgOrPngConversionResponse } from '../../../../../../../shared/models/JpgOrPngConversionResponse';
import { AlertService } from '../../../../../../../shared/services/alert.service';
import { ConversionService } from '../../../../../../../shared/services/conversion.service';
import { ProxyServiceFetchURLService } from '../../../../../../../shared/services/proxy-service-fetch-url.service';
import { PackService } from '../../../../../../contributor/components/profile/contributors/pack/services/pack.service';
import { AiImageGenerationModel } from '../../models/ai-image-generation';
import { ImageResolutionModel, IMAGE_RESOLUTIONS } from '../../models/image-resolution';
import { AiService } from '../../services/ai.service';
import { ImageFormat } from '../../../gallery/icon-gallery/models/image-format';
import { IconGalleryService } from '../../../gallery/icon-gallery/services/iconGallery.service';
import { BackgroundRemovalModel } from '../../models/background-remover';
import { NgForm } from '@angular/forms';

import { MatDialog } from '@angular/material/dialog';
import { ImagePreviewPopupComponent } from '../../../../../../../shared/components/image-preview-popup/image-preview-popup.component';
import { MergeImageRequestModel, MergeImageResponseModel } from '../../models/merge-image';
import { MergeGridRequestModel, MergeGridResponseModel } from '../../models/merge-grid';
import { BlobService } from '../../../../../../../shared/services/blob.service';
type Tabs = 'Original' | 'Merge-Grids';

@Component({
  selector: 'app-merge-grid',
    standalone:false,

  templateUrl: './merge-grid.component.html',
  styleUrl: './merge-grid.component.css'
})
export class MergeGridComponent implements OnInit {
  activeTab: Tabs = 'Original';

  allowedExtensions: string[] = ['jpg', 'png', 'jpeg'];
  mergeGridRequestModel: MergeGridRequestModel =new MergeGridRequestModel();
  mergeGridResponseModel: MergeGridResponseModel =new MergeGridResponseModel();
  isLoading: boolean = false;
  isDownloading: boolean = false;
  @ViewChild('mergeGridForm') mergeGridForm!: NgForm;
  mergeGridSubscription!: Subscription;

  images: string[] = [];
  fileError: string | null = null;
  directionEnum=DirectionEnum;
  constructor(
    private aiService: AiService,
    private alertService: AlertService,
    public proxyServiceFetchURLService: ProxyServiceFetchURLService,
     private blobService:BlobService,
    private iconGalleryService: IconGalleryService,
    private cdr: ChangeDetectorRef,
    private dialog:MatDialog,
  ) {}

  async ngOnInit() {
    this.preventBrowserDefaults()
  }

  onSelect(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.fileError = null;
    if (input.files && input.files.length > 0) {
      const duplicateFiles: string[] = [];
      const oversizedFiles: string[] = [];
      const validFiles: File[] = [];
      Array.from(input.files).forEach((file) => {
        const extension = file.name.split('.').pop()?.toLowerCase();
        const isAllowed = extension && this.allowedExtensions.includes(extension);
        const isDuplicate = this.mergeGridRequestModel.images.some((existingFile) => existingFile.name === file.name);
        const isOversized = file.size > 10 * 1024 * 1024;

        if (!isAllowed) {
          this.fileError = `Invalid file type. Please select a valid file (${this.allowedExtensions.join(', ')})`;
          return;
        }
        if (isDuplicate) {
          duplicateFiles.push(file.name);
          return;
        }
        if (isOversized) {
          oversizedFiles.push(file.name);
          return;
        }

        validFiles.push(file);
      });

      if (duplicateFiles.length > 0) {
        this.fileError = `File(s) already selected: ${duplicateFiles.join(', ')}`;
      }
      if (oversizedFiles.length > 0) {
        this.fileError = `File(s) exceed 10MB: ${oversizedFiles.join(', ')}`;
      }
      this.readFilesInOrder(validFiles);
      input.value = '';
    }
  }

  readFilesInOrder(files: File[]): void {
    const readNext = (index: number) => {
      if (index >= files.length) return;

      const file = files[index];
      const reader = new FileReader();
      reader.onload = () => {
        if (typeof reader.result === 'string') {
          this.mergeGridRequestModel.images.push(file);
          this.images.push(reader.result);
          readNext(index + 1);
        }
      };
      reader.readAsDataURL(file);
    };
    readNext(0);
  }

  removeImage(index: number): void {
    this.images.splice(index, 1);
    this.mergeGridRequestModel.images.splice(index, 1);
  }

  clear(): void {
    this.images=[];
    this.mergeGridRequestModel.images = [];
    this.mergeGridRequestModel.cols = 1;
    this.mergeGridRequestModel.rows = 1;
    this.mergeGridRequestModel.spacing = 10;
    this.mergeGridRequestModel.margin = 20;
    this.isLoading = false;
    this.isDownloading = false;
    this.activeTab = 'Original';
    this.mergeGridResponseModel.base64_image = '';
    this.mergeGridResponseModel.content_type = '';
    this.fileError = null;
    if (this.mergeGridSubscription) {
      this.mergeGridSubscription.unsubscribe();
    }
    this.cdr.detectChanges();

  }

  async mergeGrid() {
    this.isLoading = true;
    this.fileError = null;
    this.mergeGridResponseModel.base64_image = '';
    this.activeTab = 'Merge-Grids';
    this.mergeGridSubscription = await this.aiService
      .mergeGrid(this.mergeGridRequestModel)
      .subscribe({
        next: (data: MergeGridResponseModel) => {
          this.mergeGridResponseModel = data;
          this.isLoading = false;
          setTimeout(() => {
            this.cdr.detectChanges();
          }, 500);
        },
        error: (err) => {
          this.isLoading = false;
          this.fileError = err?.error?.errors?.[0].message || err?.error?.errors?.[0].errors?.[0];
        },
      });
  }

  get getImageSource():string{
      return `data:${this.mergeGridResponseModel.content_type};base64,${this.mergeGridResponseModel.base64_image}` ;
    }

  async downloadImage() {
    this.iconGalleryService.downloadBase64(
      'grid_Merged',
      this.mergeGridResponseModel.base64_image,
      this.mergeGridResponseModel.content_type.replace('image/','')
    );
    setTimeout(() => {
      this.isDownloading = false;
      this.cdr.detectChanges();
    }, 500);
  }
  setTab(tab: Tabs): void {
    this.activeTab = tab;
  }

  activeClass(tab: Tabs) {
    return tab === this.activeTab ? ' active' : '';
  }

  SetDialogWidth(): string {
    let returnWidth;
    let windowWidth = window.innerWidth;
    switch (true) {
      case windowWidth < 450: {
        returnWidth = '90%';
        break;
      }
      case windowWidth >= 450 && windowWidth < 750: {
        returnWidth = '50%';
        break;
      }
      default:
        returnWidth = '90vw';
    }
    return returnWidth;
  }

  preview() {
    let width = this.SetDialogWidth();
    const dialogRef = this.dialog.open(ImagePreviewPopupComponent, {
      maxWidth: width,
      height: '90vh',
      width: width,
      panelClass: ['center-popup', 'overflow_visible'],
      hasBackdrop: true,
      disableClose: true,

      data: {
        filepath: this.getImageSource,
      },
    });
  }

  onSpacingChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.mergeGridRequestModel.spacing = +input.value;
  }
  onMarginChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.mergeGridRequestModel.margin = +input.value;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.fileError = null;
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      const file = files[0];
      const fakeInputEvent = {
        target: { files: [file] }
      } as unknown as Event;
      this.onSelect(fakeInputEvent);
    }
  }

  allowDrop(event: DragEvent) {
    event.preventDefault();
  }

  preventBrowserDefaults() {
    ['dragover', 'drop'].forEach(eventName => {
      window.addEventListener(eventName, (e) => {
        e.preventDefault();
      }, false);
    });
  }

  ngOnDestroy(): void {
    if (this.mergeGridSubscription) {
      this.mergeGridSubscription.unsubscribe();
    }
  }
}
